export const nav = [
  {
    label: "Platform",
    to: "/ai-governance-os",
    highlight: true,
    children: [
      { label: "AI Governance OS", to: "/ai-governance-os" },
      { label: "Why AstroLife (Comparison)", to: "/comparison" },
      { label: "Documentation", to: "/documentation" },
      { label: "Request Demo / Private Beta", to: "/private-beta" },
    ],
  },
  { label: "Technology", to: "/technology" },
  {
    label: "Solutions",
    to: "/solutions",
    children: [
      { label: "Government", to: "/solutions/government" },
      { label: "Defence", to: "/solutions/defence" },
      { label: "Space", to: "/solutions/space" },
      { label: "Healthcare", to: "/solutions/healthcare" },
      { label: "Energy", to: "/solutions/energy" },
      { label: "Finance", to: "/solutions/finance" },
      { label: "Industry", to: "/solutions/industry" },
      { label: "Education", to: "/solutions/education" },
      { label: "Research", to: "/solutions/research" },
    ],
  },
  {
    label: "Resources",
    to: "/documentation",
    children: [
      { label: "Documentation", to: "/documentation" },
      { label: "Research Center", to: "/research" },
      { label: "White Paper Center", to: "/publications" },
      { label: "Blog", to: "/blog" },
      { label: "Trust Center", to: "/trust-center" },
      { label: "Knowledge Center", to: "/knowledge" },
      { label: "Download Center", to: "/downloads" },
      { label: "Media Center", to: "/media" },
    ],
  },
  { label: "Regulation", to: "/regulation" },
  { label: "Enterprise", to: "/enterprise" },
  { label: "About", to: "/about", children: [
    { label: "About AstroLife™", to: "/about" },
    { label: "AstroLife™ Universe", to: "/universe" },
    { label: "Technology", to: "/technology" },
  ] },
];

export const footerLinks = {
  Platforms: [
    { label: "AstroLife™ AI Governance OS", href: "https://governance.astrolife.es", external: true },
    { label: "Documentation", to: "/documentation" },
    { label: "Request Private Beta", to: "/private-beta" },
    { label: "Trust Center", to: "/trust-center" },
  ],
  Company: [
    { label: "About AstroLife™", to: "/about" },
    { label: "AstroLife™ Universe", to: "/universe" },
    { label: "Mission & Vision", to: "/about#mission" },
    { label: "Technology", to: "/technology" },
    { label: "Roadmap", to: "/research#roadmap" },
  ],
  Solutions: [
    { label: "Government", to: "/solutions/government" },
    { label: "Defence", to: "/solutions/defence" },
    { label: "Critical Infrastructure", to: "/solutions/energy" },
    { label: "All Solutions", to: "/solutions" },
  ],
  Resources: [
    { label: "Research & White Papers", to: "/research" },
    { label: "Knowledge Center", to: "/knowledge" },
    { label: "European Regulation", to: "/regulation" },
    { label: "Media Center", to: "/media" },
  ],
};

export const architectureFlow = ["Data", "Models", "Decision", "Orchestration", "Execution", "Logs", "Audit"];
